export default __webpack_public_path__ + "static/media/hang-glider.f2600ecb.svg";